// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Arial, Helvetica, sans-serif !important;
}
#formatted {
    white-space: pre-wrap;
  }

#roleTable {
    color: black;
}
.no-style tr {
  background-color: transparent;
}
.no-style {
  border: none;
}

.no-style th,
.no-style td {
  border: none;
}

.no-style thead th,
.no-style thead td {
  border-bottom-width: 2px;
}




.shadow-box {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  margin-top: 10px;
}

#filter_input:focus {
  outline: none !important;
  border-color:rgba(0, 0, 0, 0.24);
  box-shadow: 0 0 10px #deedfa;
}

.pointer.active.desc:after {
  content: " ▼";
  color: #390263;
}
.pointer.active.asc:after {
  content: " ▲";
  color: #02661d
}

:host ::ng-deep .ql-editor {
  min-height: 20px;
  padding-top: 0px
}
`, "",{"version":3,"sources":["webpack://./src/app/role-detail/role-detail.component.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;AACtD;AACA;IACI,qBAAqB;EACvB;;AAEF;IACI,YAAY;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,wBAAwB;AAC1B;;;;;AAKA;EACE,wFAAwF;EACxF,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF","sourcesContent":["* {\n  font-family: Arial, Helvetica, sans-serif !important;\n}\n#formatted {\n    white-space: pre-wrap;\n  }\n\n#roleTable {\n    color: black;\n}\n.no-style tr {\n  background-color: transparent;\n}\n.no-style {\n  border: none;\n}\n\n.no-style th,\n.no-style td {\n  border: none;\n}\n\n.no-style thead th,\n.no-style thead td {\n  border-bottom-width: 2px;\n}\n\n\n\n\n.shadow-box {\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  padding: 10px;\n  margin: 10px;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n#filter_input:focus {\n  outline: none !important;\n  border-color:rgba(0, 0, 0, 0.24);\n  box-shadow: 0 0 10px #deedfa;\n}\n\n.pointer.active.desc:after {\n  content: \" ▼\";\n  color: #390263;\n}\n.pointer.active.asc:after {\n  content: \" ▲\";\n  color: #02661d\n}\n\n:host ::ng-deep .ql-editor {\n  min-height: 20px;\n  padding-top: 0px\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
